(() => {
  const navToggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      const open = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
    });
  }

  document.querySelectorAll('[data-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = document.getElementById(button.getAttribute('aria-controls'));
      if (!input) return;
      const step = Number(button.dataset.qty || 0);
      const min = Number(input.min || 0);
      const max = input.max ? Number(input.max) : Infinity;
      input.value = String(Math.min(max, Math.max(min, Number(input.value || min) + step)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mainImage = gallery.querySelector('.clean-product__main-image');
    const thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const nextSrc = thumb.dataset.fullSrc;
        if (!nextSrc) return;

        mainImage.src = nextSrc;
        mainImage.removeAttribute('srcset');
        mainImage.alt = thumb.dataset.alt || mainImage.alt;

        thumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.removeAttribute('aria-current');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  });

})();
